import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 – Ingen adgang – Krüger Wet Blaster ApS"
        description="Du har ikke adgang til denne side."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl border border-slate-200/90 shadow-sm">
          <div className="w-16 h-16 rounded-2xl bg-amber-50 border border-amber-200 text-amber-600 flex items-center justify-center mx-auto text-2xl font-mono font-bold">
            403
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
              Ingen adgang (403 Forbidden)
            </h1>
            <p className="text-sm text-slate-600 leading-relaxed">
              Du har desværre ikke tilladelse til at tilgå denne ressource eller side.
            </p>
          </div>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold text-sm px-5 py-2.5 rounded-lg shadow-sm transition-colors"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-medium text-sm px-5 py-2.5 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-headset text-xs" aria-hidden="true" />
              <span>Kontakt support</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
